export default "__VITE_ASSET__BTEuW32M__";